<template>
  <div class="body">
    <header>
      <div class="title">
        <div class="title_left" @click="go()" id="backHome">
          返回
        </div>
        <div class="title_right">
          <span>旧版入口:</span> <a v-for="(item, index) in modelList" :key="index" :href="item.path">{{item.name}}</a>
        </div>
      </div>
    </header>
    <div style="width: 100%;height: calc(100% - 40px);padding-top: 40px; box-sizing: border-box;">
      <iframe :src="url" width="100%" height="100%" frameborder="0"></iframe>
    </div>
  </div>
</template>
<script>

export default {
  data () {
    const Authorization = JSON.parse(localStorage.getItem('Authorization'))
    return {
      url: '',
      modelList: [
        // 正式
        { name: '瀚洋oa', path: 'https://app.hanyangtelecom.com/hanyang-oa/a/sys/oatoken/check?token=' + Authorization.val },
        { name: '智慧人力', path: 'https://app.hanyangtelecom.com/hr/base/login?token=' + Authorization.val },
        { name: '瀚洋之音', path: 'https://app.hanyangtelecom.com/wechat/outside/' + Authorization.val }
        // 测试
        // { name: '瀚洋oa', path: 'http://58.34.191.202:8884/hyoa/a/sys/oatoken/check?token=' + Authorization.val },
        // { name: '智慧人力', path: ' http://58.34.191.202:8000/hr/base/login?token=' + Authorization.val },
        // { name: '瀚洋之音', path: 'http://58.34.191.202:8000/wechat/outside/' + Authorization.val }
      ]
    }
  },
  created () {
    // 此处urlType不为空表示：待办已办跳转，不需要拼接goTo参数，否则处理待办提交时会报错
    if (this.$route.query && this.$route.query.urlType) {
      this.url = this.$route.query.url + '&token=' + JSON.parse(localStorage.getItem('Authorization')).val
    } else {
      // 此处urlType为空表示：功能菜单跳转，需要拼接goTo参数指明菜单路径
      // 测试
      // this.url = this.$route.query.url.testUrl + '?token=' + JSON.parse(localStorage.getItem('Authorization')).val + '&goTo=' + this.$route.query.path
      // 正式
      this.url = this.$route.query.url.url + '?token=' + JSON.parse(localStorage.getItem('Authorization')).val + '&goTo=' + this.$route.query.path
    }
    console.log(this.url)
  },
  methods: {
    go () {
      if (this.$route.query && this.$route.query.urlType) {
        this.$router.push({path: '/home', query: {activeName: '1'}})
      } else {
        this.$router.push({path: '/home', query: {activeName: '2'}})
      }
    }
  }
}
</script>
<style scoped lang="scss">
  .body {
    width: 100%;
    height: 100vh;
    header {
      width: 100%;
      height: 40px;
      line-height:40px;
      background-color: #f0f0f0;
      position: fixed;

      .title {
        width: 80%;
        margin: 0 auto;
        display: flex;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: space-between;

        .title_left {
          font-size: 18px;
          font-weight: 700;
          display: flex;
          align-items: center;
          font-family: cursive
        }

        .title_right {
          font-size: 13px;
          display: flex;
          justify-content: space-between;
          align-items: center;
          a{
            font-size: 14px;
            color: #629bd7;
            padding: 0 6px;
            box-sizing: border-box ;
            a:hover{
              color: #45bdf5;
            }
          }
        }
      }
    }
    .main {
      width: 80%;
      margin: 0 auto;
      .content_first{
        width: 100%;
        background-color: white;
      }
    }
  }
</style>



// WEBPACK FOOTER //
// src/views/system.vue